import { Navigate, Outlet } from "react-router";
import useAuth from "../hooks/useAuth";

const RequireAuth = () => {
    const { auth } = useAuth();

    return (
        auth?.user ? <Outlet /> : <Navigate to="/unauthorized" />
    );
}

export default RequireAuth;